
<template>
  <div class="addAppVersion">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="jump()">{{$t('lang.btn_backUniapp')}}</el-button>
      </div>
      <el-form :rules="rules" ref="form" :model="form" class="form_show" :label-width="require('@/config/enum').c_ws8" :label-suffix="require('@/config/enum').c_colon">
        
        <el-form-item :label="$t('lang.lab_mobile')" prop="appAreaValues" ref="appAreaValues">
         <upload-file ref="uploading" :accept='accept' :fileList='form.fileList' :clears='clears'  @outputFile="getFile" @removeFile='removeFile' upTypes='3'></upload-file>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_uri')" prop="uri" v-if="form.appAreaValue === '2'">
          <el-input v-model="form.uri" :placeholder="$t('lang.lab_uri')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_uniappVersionCode')" prop="versionCode">
          <el-input v-model="form.versionCode" :placeholder="$t('lang.lab_uniappVersionCode')"></el-input>
        </el-form-item>   
        <el-form-item :label="$t('lang.lab_resourceId')" prop="versionName">
          <el-input v-model="form.versionName" :placeholder="$t('lang.lab_resourceId')"></el-input>
        </el-form-item>
          <el-button @click="rest('form')" class="btn-first">{{$t('lang.btn_rest')}}</el-button>
          <el-button
            type="primary"
            class="detailbtn"
            @click="onSubmit('form')"
          >{{$t('lang.btn_save')}}</el-button>
      </el-form>
    </el-card>
  </div>
</template>
<script>
/**
 *@ClassName:addAppVersion
 *@Description:添加APP版本
 *@author:刘彦辰
 *@Copyright:格众科技
 *@date:2020-03-16
 */
import UploadFile from '../../../components/upload_file.vue'
export default {
  data() {
    return {
      accept: '.wgt',
      clears: false, // 清空按钮
      form: {
        appAreaValues: '',
        mobile: '',
        uri: '',
        versionCode: '',
        appId: '0',
        appAreaValue: '0',
        upgradeLevel: '0',
        versionName: '',
        title: '',
        content: '',
        fileList: [],
      }, // 对象
      rules: {
        appAreaValues: [
          { required: true, message: this.$i18n.t('lang.lab_please_Upload'), trigger: 'blur' }
        ],
        versionCode: [
          { required: true, message: this.$i18n.t('lang.key_uniappVersionCode'), trigger: 'blur' }
        ],
        versionName: [
          { required: true, message: this.$i18n.t('lang.key_resourceId'), trigger: 'blur' }
        ]
        
      }, // 表单验证
      appType: this.$i18n.t('lang.appVersionManagement.appType'), // 下拉列表
      appUpdate: this.$i18n.t('lang.appVersionManagement.appUpdate'), // 下拉列表
      appArea: this.$i18n.t('lang.appVersionManagement.appArea') // 下拉列表
    }
  },
  components: {
		'upload-file': UploadFile
  },
   destroyed() {
    window.localStorage.setItem('appbbform', JSON.stringify(this.form))
  },
  created() {
    if (window.localStorage.getItem('appbbform')) {
      this.form = JSON.parse(window.localStorage.getItem('appbbform'))
      if (this.form.appAreaValues) {
         this.form.fileList.push({
            name: '',
            url: this.form.appAreaValues
          })
      }
    }
  },
  methods: {
     // 获取组件值
    getFile(e) {
      this.form.appAreaValues = e
      this.$refs.appAreaValues.clearValidate()
    },
    // 移除图片
    removeFile(e) {
      this.form.fileList = []
      this.form.appAreaValues = ''
    },
  // 清空表单
    rest(form) {
      this.form.fileList = []
      this.clears = true
      this.$refs.form.resetFields()
      this.form.appAreaValues = ''
      this.form.mobile = ''
      this.form.uri = ''
      this.form.versionCode = ''
      this.form.appId = '0'
      this.form.appAreaValue = '0'
      this.form.upgradeLevel = '0'
      this.form.versionName = ''
      this.form.title = ''
      this.form.content = ''
     },
   onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
           let parse = {
            versionCode: this.form.versionCode,
            versionName: this.form.versionName,
            imgUri: this.form.appAreaValues
          }
          let loading = this.$loading()
          // POST接口不好使时，用如下方式进行请求
          this.$post(`/versionUniapp/upload`, parse).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_save_success'))
                this.$router.push({ name: 'UniappVersion' })
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        }
      })
    },
    jump() {
      this.$router.push({ name: 'UniappVersion' })
    },
  }
}
</script>

<style lang="scss">
.addAppVersion .form {
  text-align: left;
}
.addAppVersion .select {
  width: 100%;
}
.addAppVersion .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
.addAppVersion .el-form-item__content {
  width: 60vw !important;
}
.addAppVersion.el-main {
  padding: 0px;
}
</style>